<template>
<div>
  <div class="cliqueDe">
    <el-form label-width="120px">
      <label class="title">查看协助申请单</label>
      <el-row class="repairTitle">申请信息</el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="所属门店:">{{dealDet.shopName}}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="提报时间:">{{dealDet.createDate}}</el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="联系手机号:">{{dealDet.applyPhone}}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="姓名:">{{dealDet.applyName}}</el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="申请类型:">{{dealDet.applyTypeName}}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="希望协助时间:">{{dealDet.assistDateStart}} - {{dealDet.assistDateEnd}}</el-form-item>
        </el-col>
      </el-row>
      <div class="lineStyle"></div>
      <el-row class="repairTitle">处理信息</el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="处理人:">{{dealDet.dealName}}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="处理时间:">{{dealDet.dealTime}}</el-form-item>
        </el-col>
      </el-row>
      <div class="lineStyle"></div>
      <el-row class="repairTitle">协助信息</el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="协助人:">{{dealDet.assistName}}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="预计下店时间:">{{dealDet.expectInnDate}}</el-form-item>
        </el-col>
      </el-row>
      <div v-if="dealDet.applyStatus != 1 && dealDet.applyStatus != 2">
      <el-row>
        <el-col :span="8">
          <el-form-item label="签到时间:">{{dealDet.signInDate}}</el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="门店经纬度:">{{dealDet.coordinateSignInShop}}</el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="协助人经纬度:">{{dealDet.coordinateSignInAssist}}</el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="dealDet.applyStatus != 3">
        <el-col :span="8">
          <el-form-item label="签退时间:">{{dealDet.signBackDate}}</el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="门店经纬度:">{{dealDet.coordinateSignBackShop}}</el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="协助人经纬度:">{{dealDet.coordinateSignBackAssist}}</el-form-item>
        </el-col>
      </el-row>
      </div>
      <el-row>
        <el-col :span="8" style="margin:0 0 20px 40px;">
          <el-button type="danger" v-if="dealDet.applyStatus == 2" @click="inSign">到店签到</el-button>
          <el-button type="danger" v-if="dealDet.applyStatus == 3" @click="backSign">离店签退</el-button>
        </el-col>
      </el-row>
      <div class="lineStyle"></div>
      <el-row class="repairTitle">评价信息</el-row>
      <el-row>
        <el-col :span="11">
          <el-row class="repairTitle" style="font-size: 14px;font-weight:normal; text-align: center;">对协助人员评价</el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="下店服务:"><el-rate v-model="innAssist.innServices" style="line-height:2.5;"></el-rate></el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="培训服务:"><el-rate v-model="innAssist.trainingServices" style="line-height:2.5;"></el-rate></el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-form-item label="销售活动:"><el-rate v-model="innAssist.salesActivities" style="line-height:2.5;"></el-rate></el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="评价:">{{innAssist.evaluation}}</el-form-item>
          </el-row>
        </el-col>
        <el-col :span="12" class="fr">
          <el-row class="repairTitle" style="font-size: 14px;font-weight:normal; text-align: center;">对协助门店评价</el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="门店环境:"><el-rate v-model="innShop.shopEnvironment" style="line-height:2.5;"></el-rate></el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="老板配合度:"><el-rate v-model="innShop.bossCompatibility" style="line-height:2.5;"></el-rate></el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="主任执行力:"><el-rate v-model="innShop.chiefExecutive" style="line-height:2.5;"></el-rate></el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="顾问销售能力:"><el-rate v-model="innShop.consultantSalesAbility" style="line-height:2.5;"></el-rate></el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="团队凝聚力:"><el-rate v-model="innShop.teamCohesion" style="line-height:2.5;"></el-rate></el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="专业知识技能:"><el-rate v-model="innShop.knowledgeSkills" style="line-height:2.5;"></el-rate></el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-form-item label="评价:">{{innShop.evaluation}}</el-form-item>
          </el-row>
        </el-col>
      </el-row>
      <el-row class="btnOptions">
        <span v-if="dealDet.applyStatus == 1 || dealDet.applyStatus == 4">
          <el-button type="primary" v-if="dealDet.applyStatus == 1" @click="evaRemove" plain>取消申请</el-button>
          <el-button type="primary" v-if="dealDet.applyStatus == 4" @click="evaluatE" plain>我要评价</el-button>
        </span>
        <el-button type="info" @click="cancelEdit" plain>关闭</el-button>
      </el-row>
    </el-form>
  </div>
  <el-dialog title="对本次下店服务评价" :visible.sync="dialogVisible" :center="true" top="80px" width="350px">
    <el-form label-width="90px">
      <el-form-item label='下店服务:'>
        <el-rate v-model="innServices" style="line-height:2.5;"></el-rate>
      </el-form-item>
      <el-form-item label='销售活动:'>
        <el-rate v-model="salesActivities" style="line-height:2.5;"></el-rate>
      </el-form-item>
      <el-form-item label='培训服务:'>
        <el-rate v-model="trainingServices" style="line-height:2.5;"></el-rate>
      </el-form-item>
      <el-form-item label='输入评价:'>
        <el-input type="textarea" v-model="evaluation" style="width:80%;height:100px;" placeholder="请输入,限制200字" resize="none" maxlength="200"></el-input>
      </el-form-item>
      <el-row style="width:70%;margin: 8% auto 3%;">
        <el-button style="padding: 9px 13px;" @click="cancelEva">取消评价</el-button>
        <el-button type='primary' style="padding: 9px 13px;margin-right:3%;" @click="submitEva">提交评价</el-button>
      </el-row>
    </el-form>
  </el-dialog>
</div>
</template>
<script>
import { formatDate} from '@/components/common/js/date.js';
import {viewInnOrder, cancleApplyOrder, signIn, signBack, innAssistEvaluation} from "@/api";
export default {
  data() {
    return {
      vale1:0,
      dealDet:{},
      innAssist:{
        innServices:0,
        trainingServices:0,
        salesActivities:0,
        evaluation:''
      },
      innShop:{
        shopEnvironment:0,
        bossCompatibility:0,
        chiefExecutive:0,
        consultantSalesAbility:0,
        teamCohesion:0,
        knowledgeSkills:0,
        evaluation:''
      },
      dialogVisible:false,
      salesActivities:0,
      trainingServices:0,
      innServices:0,
      evaluation:'',
    };
  },
  watch: { // 如果路由有变化，会再次执行该方法
      $route: "viewInn"
   },
  created(){
    this.viewInn();
  },
  methods: {
    evaluatE(){
      if(this.dealDet.isShopEvaluation == 0){
        this.$message({
          message:'下店人员尚未对门店进行评价',
          type:'warning'
        });
        this.cancelEdit();
      }else{
        this.dialogVisible = true
      }
    },
    submitEva(){
      innAssistEvaluation({
        innId:this.$route.params.id,
        innServices:this.innServices,
        trainingServices:this.trainingServices,
        salesActivities:this.salesActivities,
        evaluation:this.evaluation,
        systemType:this.$store.state.userInfo.brandId
      }).then(res => {
       this.innServices = 0;
       this.trainingServices = 0;
       this.salesActivities = 0;
       this.evaluation = '';
       this.$message({
         message:res.msg,
         type:'success'
       });
       this.selectAl();
       this.cancelEva();
      });
    },
    cancelEva(){//取消
      this.innServices = 0;
      this.trainingServices = 0;
      this.salesActivities = 0;
      this.evaluation = '';
      this.dialogVisible = false
    },
    inSign(){ //签到
      let postData = {
        innId:this.$route.params.id,
        systemType:this.$store.state.userInfo.brandId,
        coordinateSignInShop:'562',
        coordinateSignInAssist:'585'
      }
      signIn(postData).then(res =>{
        this.$message({
          message:res.msg,
          type:'success'
        });
        this.viewInn()
      })
    },
    backSign(){ //签退
      let postDatas = {
        innId:this.$route.params.id,
        systemType:this.$store.state.userInfo.brandId,
        coordinateSignBackShop:'562',
        coordinateSignBackAssist:'585'
      }
      signBack(postDatas).then(res =>{
        this.$message({
          message:res.msg,
          type:'success'
        });
        this.viewInn();
      })
    },
    evaRemove(){
      cancleApplyOrder({
        systemType:this.$store.state.userInfo.brandId,
        innId:this.$route.params.id
      }).then(res => {
        this.$message({
          message:res.msg,
          type:'warning'
        });
        this.cancelEdit();
      });
    },
    viewInn() {
      viewInnOrder({
        innId:this.$route.params.id,
        systemType:this.$store.state.userInfo.brandId
      }).then(res => {
        this.dealDet = res.obj;
        if(this.dealDet.innAssist[0] != null){
          this.innAssist = {
            innServices:this.dealDet.innAssist[0].innServices,
            trainingServices:this.dealDet.innAssist[0].trainingServices,
            salesActivities:this.dealDet.innAssist[0].salesActivities,
            evaluation:this.dealDet.innAssist[0].evaluation
          }
        };
        if(this.dealDet.innShop[0] != null){
          this.innShop = {
            shopEnvironment:this.dealDet.innShop[0].shopEnvironment,
            bossCompatibility:this.dealDet.innShop[0].bossCompatibility,
            chiefExecutive:this.dealDet.innShop[0].chiefExecutive,
            consultantSalesAbility:this.dealDet.innShop[0].consultantSalesAbility,
            teamCohesion:this.dealDet.innShop[0].teamCohesion,
            knowledgeSkills:this.dealDet.innShop[0].knowledgeSkills,
            evaluation:this.dealDet.innShop[0].evaluation
          }
        };
        if(this.dealDet.createDate){
          this.dealDet.createDate = formatDate(this.dealDet.createDate, 'yyyy-MM-dd HH:mm')
        }
        if(this.dealDet.assistDateStart){
          this.dealDet.assistDateStart = formatDate(this.dealDet.assistDateStart, 'yyyy-MM-dd HH:mm')
        }
        if(this.dealDet.assistDateEnd){
          this.dealDet.assistDateEnd = formatDate(this.dealDet.assistDateEnd, 'yyyy-MM-dd HH:mm')
        }
        if(this.dealDet.dealTime){
          this.dealDet.dealTime = formatDate(this.dealDet.dealTime, 'yyyy-MM-dd HH:mm')
        }
        if(this.dealDet.expectInnDate){
          this.dealDet.expectInnDate = formatDate(this.dealDet.expectInnDate, 'yyyy-MM-dd HH:mm')
        }
        if(this.dealDet.signInDate){
          this.dealDet.signInDate = formatDate(this.dealDet.signInDate, 'yyyy-MM-dd HH:mm')
        }
        if(this.dealDet.signBackDate){
          this.dealDet.signBackDate = formatDate(this.dealDet.signBackDate, 'yyyy-MM-dd HH:mm')
        }
      });
    },
    cancelEdit() {
      this.$store.commit("delete_tabs", this.$route.path);
      // //设置当前激活的路由
      // if (this.options && this.options.length >= 1) {
      //   this.$store.commit(
      //     "set_active_index",
      //     this.options[this.options.length - 1].route
      //   );
      //   this.$router.push({ path: this.activeIndex });
      // }
     this.$router.push('/cliqueBusinessCenter/cliqueWork')
    },

  }
};
</script>
<style lang="less" scoped>
.cliqueDe {
  width: 100%;
  overflow: hidden;
  padding: 33px 50px 70px;
  .title{
    font-size: 18px;text-align: center;display: block;
  }
  .repairTitle{font-weight: bold;  font-size: 16px; margin-bottom: 23px;}
  .lineStyle {
    background-color: #DEE6EA;
    height: 1px;
    margin: 10px auto 35px;
  }
}
</style>
<style lang="less">
.cliqueDe .btnOptions {
  text-align: center; position: fixed;bottom: 3%;left:0;right: 0;
  margin:0 auo ;
  .el-button {
    width: 135px;
    height: 46px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/groupWork/cliqueDtails.vue